import { render, staticRenderFns } from "./AddSecondSaleCategoryModal.vue?vue&type=template&id=0f875e93&scoped=true&"
import script from "./AddSecondSaleCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddSecondSaleCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSecondSaleCategoryModal.vue?vue&type=style&index=0&id=0f875e93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f875e93",
  null
  
)

export default component.exports